

































































import { Component, Vue, Prop } from "vue-property-decorator";
import {  ICustomer } from "@/interfaces";
import { HELPER } from '@/utils/Helper';
@Component({})
export default class CustomerDataComponent extends Vue {
	@Prop({ required: true }) cust: ICustomer;
	
	public H: HELPER = HELPER;

  public HasFlag(id: number): boolean {
		if (!this.cust || !this.cust.CustType 
		|| !this.cust.CustType.CustTypeFlags) return false;
    var iof = this.cust.CustType.CustTypeFlags.indexOf(id);
		var hasIt: boolean = iof > -1;
    return hasIt;
  }

}
